import React from "react";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Header } from "./Header";
import { OnboardingBanner } from "@/components/onboarding/OnboardingBanner";
import { useBranding } from "@/hooks/useBranding";

interface MainLayoutProps {
  children: React.ReactNode;
  /** Disable default padding (p-4 sm:p-6) on the main container */
  noPadding?: boolean;
}

export const MainLayout = ({
  children,
  noPadding = false,
}: MainLayoutProps) => {
  const { branding } = useBranding();

  return (
    <SidebarProvider>
      <div className="h-screen flex w-full bg-background">
        <AppSidebar />
        {/* 
          Layout uses flexbox with flex-shrink-0 for fixed headers (Header, OnboardingBanner)
          and overflow-hidden to constrain height chain for pages like Messages.
        */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <Header />
          <OnboardingBanner />
          <main
            className={`flex-1 overflow-auto ${
              noPadding ? "" : "p-4 sm:p-6"
            }`}
          >
            {children}
          </main>
          {branding.dashboard_footer && (
            <footer className="border-t bg-muted/30 px-4 py-2 text-center text-xs text-muted-foreground flex-shrink-0">
              {branding.dashboard_footer}
            </footer>
          )}
        </div>
      </div>
    </SidebarProvider>
  );
};
